import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
    errorMessage,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { updatePayrateRoute, updateRockerboxWotcRoute } from '../api/constant';
import { rockerboxApplicantKey, rockerboxEmployerKey } from '../constants';

type useUpdatePayrateProps = {
    setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useUpdatePayrate = ({
    setErrorText = () => { },
}: useUpdatePayrateProps) => {
    const client = useQueryClient();

    const { mutate: updatePayrate, isLoading: isUpdatePayrateLoading } =
        useMutation({
            mutationFn: (variables: {
                application_id: number | string;
                pay_rate: string
                pay_rate_type: string
                tips?: string | number
                hours_worked?: string | number
            }) =>
                axiosInstance
                    .post(updatePayrateRoute, variables, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                    .then((res) => res.data),
            onSuccess: (data) => {
                client.invalidateQueries([rockerboxApplicantKey]);
                setErrorText('');
            },
            onError: () => {
                setErrorText(errorMessage);
            },
        });

    return {
        updatePayrate,
        isUpdatePayrateLoading,
    };
};
